import { ReactNode } from 'react';
import { useNetworkStatus } from '@/hooks';

interface NetworkStatusProviderProps {
  children: ReactNode;
}

export function NetworkStatusProvider({ children }: NetworkStatusProviderProps) {
  useNetworkStatus();
  return children;
}
